/**
 * PublicCatalog_Service.ts
 * Read-only published-catalog views  (sk-catalog-api /api/v1/public/items)
 *
 * These return the tenant's PUBLISHED items in their resolved, customer-facing
 * shape — used by the in-app "Site" preview.
 */

import axiosInstance from '../../api/axiosInstance';
import {
  Catalog_Public_Items_Url,
  Catalog_Public_Item_Url,
} from '../../api/endpoints';
import { PublicItem, PublicItemResponse, PublicItemsResponse } from '../../schemas/catalog/publicCatalog';

/* ─────────────────────────────────────────
   List published items — GET /api/v1/public/items
───────────────────────────────────────── */

export const getPublicItems = async (params?: Record<string, any>): Promise<PublicItemsResponse> => {
  const { data } = await axiosInstance.get<PublicItemsResponse>(Catalog_Public_Items_Url, { params });
  return data;
};

/* ─────────────────────────────────────────
   Get one published item — GET /api/v1/public/items/:id
───────────────────────────────────────── */

export const getPublicItem = async (id: string): Promise<PublicItemResponse> => {
  const { data } = await axiosInstance.get<PublicItemResponse>(Catalog_Public_Item_Url(id));
  return data;
};

export type { PublicItem };
